import { useState } from 'react';
import { Form, Formik, Field } from 'formik';
import * as Yup from 'yup';
import fetch from 'isomorphic-fetch';
import Spinner from 'react-bootstrap/Spinner';
import img from './contact-img.jpeg';
import PageTitle from '../../components/page-title';
import Splash from '../../components/splash';

const ContactSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Too Short')
    .max(50, 'Too Long')
    .required('Required'),
  message: Yup.string()
    .min(2, 'Too Short')
    .max(500, 'Too Long')
    .required('Required'),
  email: Yup.string()
    .email('Invalid email')
    .required('Required'),
  address: Yup.string()
    .min(5, 'Too Short')
    .max(500, 'Too Long'),
  referenceNumber: Yup.string()
    .min(3, 'Too Short')
    .max(25, 'Too Long')
});

const API_ROOT = 'https://0b52nyxc0j.execute-api.eu-west-1.amazonaws.com/dev/contact-form';

function Contact() {
  const phone = process.env.REACT_APP_PHONE_NUMBER || '';
  const siteUrl = process.env.REACT_APP_SITE_URL || 'premierparkinglogistics.com';
  
  return (
    <div className='h-auto'>
      <Splash src={img} title='Contact Us' />
      <div className='p-4 pb-32 max-w-6xl mx-auto'>
        <PageTitle title='Contact Us' />
        
        <div className="space-y-8">

          {/* Contact Methods Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            {/* Phone Contact */}
            <div className="bg-white shadow-lg rounded-lg p-6 text-center hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-amber-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-2xl">📞</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Phone</h3>
              <a href={`tel:01212361878`} className="text-amber-500 hover:text-amber-600 font-semibold text-lg">
                0121 2361878
              </a>
            </div>

            {/* Email Contact */}
            <div className="bg-white shadow-lg rounded-lg p-6 text-center hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-2xl">✉️</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Email</h3>
              <p className="text-gray-600 mb-3">Queries (Appeals not accepted)</p>
                             <a 
                 href={`mailto:info@${siteUrl}`} 
                 className="text-blue-500 hover:text-blue-600 font-semibold break-words"
               >
                 info@{siteUrl}
               </a>
            </div>

            {/* Address Contact */}
            <div className="bg-white shadow-lg rounded-lg p-6 text-center hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-2xl">📍</span>
              </div>
              <p className="text-xl font-semibold text-gray-800 mb-2">Address</p>
              <div className="text-gray-700">
                <p>Office 3 Block 4</p>
                <p>Mint Drive</p>
                <p>Birmingham B18 6EA</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function ContactForm(props) {
  const [complete, setComplete] = useState(false);
  return (
    <div className='contact content-body'>
      <h2>Contact</h2>
      <h3>{complete ? 'Message sent!' : ''}</h3>
      <Formik
        initialValues={{
          name: '',
          email: '',
          reference: '',
          address: '',
          message: '',
        }}
        validationSchema={ContactSchema}
        onSubmit={ async (values, actions) => {
          actions.setSubmitting(true);
          return fetch(API_ROOT, {
            body: JSON.stringify(values),
            method: 'POST',
            headers: {
              'content-type': 'application/json',
            },
          })
          .then(res => res.json())
          .then(res => {
            actions.setStatus({ submitted: true });
            actions.resetForm();
            setComplete(true);
          })
          .catch(err => {
            actions.setStatus({ err });
            actions.resetForm();
          });
        }}>
        {({ errors, touched, status, isSubmitting }) => (
          <Form className='form-group'>
            <p>{isSubmitting ? 'Message sent!' : ''}</p>
            {isSubmitting ? (
              <Spinner />
            ) : (
              <div>
                <Field name="name" className='form-control' placeholder='Name' />
                {errors.name && touched.name ? (
                  <div>{errors.name}</div>
                  ) : null}
                <br />
                <Field name="email" type="email" className='form-control' placeholder='E-Mail' />
                  {errors.email && touched.email ? <div>{errors.email}</div> : null}
                <br />
                <Field name="reference" className='form-control' placeholder='Reference Number' />
                  {errors.email && touched.email ? <div>{errors.email}</div> : null}
                <br />
                <Field
                  name="address"
                  component="textarea"
                  className='form-control message'
                  placeholder='Address' />
                {errors.address && touched.address ? (
                  <div>{errors.address}</div>
                  ) : null}
                <br />
                <Field
                  name="message"
                  component="textarea"
                  className='form-control message'
                  placeholder='Message...' />
                {errors.message && touched.message ? (
                  <div>{errors.message}</div>
                  ) : null}
                <br />
                <button type="submit" className='btn btn-dark'>Submit</button>
              </div>
            )}
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default Contact;

